import styled from 'styled-components';

export const MultiTradeInAccordionGroupContainer = styled.div`
    position: relative;
    & .MuiAccordion-root {
        background-color: transparent;
        border-radius: 0 !important;
        border-width: 0 0 1px 0;
        margin-bottom: 16px;
        & > div:first-of-type {
            padding: 0;
            & .MuiButtonBase-root {
                padding-left: 4px;
            }
        }
        &.Mui-expanded > div:first-of-type {
            margin-bottom: 16px;
        }
        & .MuiAccordionDetails-root {
            padding: 0 0 16px 0;
        }
    }
`;
